import {IIdentityAbiClient} from "../../auth-management/authentication/clients/identity-api-client.interface";
import {InjectionToken} from "@angular/core";

export const IDENTITY_ABI_CLIENT = new InjectionToken<IIdentityAbiClient>('IIdentityAbiClientInterface');

